export const list = {
  list: {
    shape:
      '<path fill="#000" fill-opacity=".98" d="M4 20.775V3.225l1.275.975 1.35-.975L7.95 4.2l1.35-.975 1.35.975L12 3.225l1.35.975 1.35-.975 1.35.975 1.325-.975 1.35.975L20 3.225v17.55l-1.275-.975-1.35.975-1.325-.975-1.35.975-1.35-.975-1.35.975-1.35-.975-1.35.975-1.35-.975-1.325.975-1.35-.975L4 20.775Zm2.5-4.9h11v-1h-11v1Zm0-3.375h11v-1h-11v1Zm0-3.375h11v-1h-11v1ZM5 19.1h14V4.9H5v14.2Z"/>',
    viewBox: [0, 0, 24, 24],
  },
};
